export const COLUMNS = [
    "Backlog",
    "To Do",
    "In Progress",
    "In Review",
    "Done",
];
export const DEFAULT_SPACE_ID = "default";
export const EVENT_KINDS = [
    "comment",
    "journal_entry",
    "task_created",
    "column_changed",
    "assigned_to_changed",
    "reported_by_changed",
    "due_date_changed",
    "blocker_added",
    "blocker_removed",
    "project_changed",
    "space_changed",
    "tags_changed",
    "task_archived",
    "task_unarchived",
];
export const AVATAR_EMOJI_LIST = [
    "🦊", "🦁", "🐯", "🐼", "🐨",
    "🐮", "🐸", "🐵", "🐧", "🦉",
    "🦄", "🐙", "🦋", "🌸", "🌻",
    "🌈", "⭐", "🔥", "⚡", "🚀",
    "🎨", "🎯", "🧠", "💡", "☕",
    "🌊", "🍀", "🍄", "🎵", "🧩",
];
export const RESERVED_HANDLES = [
    "me", "admin", "system", "api", "app", "root",
    "support", "help", "fjord", "agent",
    "user", "users", "openclaw",
];
export const HANDLE_REGEX = /^[a-z0-9_-]{1,32}$/;
export const DEFAULT_ADMINISTRATOR_ID = "default-administrator";
export const DOMAIN_ERROR_CODES = [
    "handle_invalid",
    "handle_reserved",
    "handle_taken",
    "avatar_invalid",
    "set_password_required",
    "version_conflict",
    "subsequent_activity",
    "edit_window_expired",
];
const RESERVED_HANDLE_SET = new Set(RESERVED_HANDLES.map((h) => h.toLowerCase()));
/**
 * Lowercase, collapse whitespace to `-`, strip non `[a-z0-9_-]` chars,
 * collapse repeated `-`, trim leading/trailing `-`, truncate to 32 chars.
 * Returns "" if nothing survives.
 */
export function slugify(input) {
    return input
        .toLowerCase()
        .replace(/\s+/g, "-")
        .replace(/[^a-z0-9_-]/g, "")
        .replace(/-+/g, "-")
        .replace(/^-+|-+$/g, "")
        .slice(0, 32);
}
/** Deterministic 32-bit hash — same string → same number. */
export function hashCode(input) {
    let h = 0;
    for (let i = 0; i < input.length; i++) {
        h = (h * 31 + input.charCodeAt(i)) | 0;
    }
    return Math.abs(h);
}
export function pickAvatar(userId) {
    return AVATAR_EMOJI_LIST[hashCode(userId) % AVATAR_EMOJI_LIST.length];
}
export function validateHandle(input) {
    const lower = input.toLowerCase();
    if (!HANDLE_REGEX.test(lower)) {
        return {
            ok: false,
            code: "handle_invalid",
            message: `Handle must match ${HANDLE_REGEX.source} (1-32 chars, lowercase letters, digits, _, -)`,
        };
    }
    if (RESERVED_HANDLE_SET.has(lower)) {
        return { ok: false, code: "handle_reserved", message: `Handle "${lower}" is reserved` };
    }
    return { ok: true, value: lower };
}
function countGraphemes(input) {
    if (typeof Intl !== "undefined" && typeof Intl.Segmenter === "function") {
        const seg = new Intl.Segmenter(undefined, { granularity: "grapheme" });
        let n = 0;
        for (const _ of seg.segment(input))
            n++;
        return n;
    }
    let n = 0;
    for (const _ of input)
        n++;
    return n;
}
export function validateAvatar(input) {
    if (!input) {
        return { ok: false, code: "avatar_invalid", message: "Avatar is required" };
    }
    if (input.startsWith("http://") || input.startsWith("https://")) {
        if (input.length > 2048) {
            return { ok: false, code: "avatar_invalid", message: "Avatar URL too long (max 2048 chars)" };
        }
        return { ok: true, value: input };
    }
    let hasNonAscii = false;
    for (const ch of input) {
        if (ch.codePointAt(0) > 127) {
            hasNonAscii = true;
            break;
        }
    }
    if (!hasNonAscii) {
        return { ok: false, code: "avatar_invalid", message: "Avatar must be an emoji or http(s) URL" };
    }
    if (countGraphemes(input) !== 1) {
        return { ok: false, code: "avatar_invalid", message: "Avatar must be a single emoji" };
    }
    return { ok: true, value: input };
}
export function canArchive(task) {
    return task.column === "Done" && !task.archived;
}
export function isBlockerSatisfied(blocker) {
    return blocker.column === "Done" || blocker.archived;
}
export function isTaskBlocked(task, taskById) {
    for (const blockerId of task.blocked_by) {
        const blocker = taskById.get(blockerId);
        if (blocker && !isBlockerSatisfied(blocker))
            return true;
    }
    return false;
}
//# sourceMappingURL=index.js.map